import bootLayout from 'static/script/app/boot/boot-layout';
import Pagination from 'static/script/app/ui/search-result/pagination';
import ClickableListItem from 'static/script/app/ui/clickable-list-item';
import MemberSearchUI from 'static/script/app/ui/member-search-ui';
import breakpoints from 'static/script/utils/breakpoints';

module.exports = initData => {
    bootLayout(initData);
    Pagination.attachTo('[data-pagination]');
    MemberSearchUI.attachTo('[data-member-search]');

    if (!breakpoints.isVisible(breakpoints.xlarge)) {
        ClickableListItem.attachTo('[data-clickable-list-item]', {initData: initData});
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/member-search.js